import { createContext } from 'react';
import { IModalAttachment } from '../../../../entities/attachment/model/IModalAttachment.interface';
import { IAttachmentResponse } from '../../../../entities/task/model/types/tasks';

interface IModalContext {
    attachments: (IModalAttachment | IAttachmentResponse)[];
}

export const ModalContext = createContext<IModalContext>({
    attachments: [],
});
